export async function sLoad<T>(key: string, def: T): Promise<T> {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : def;
  } catch {
    return def;
  }
}

export async function sSave(key: string, val: unknown): Promise<void> {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch {}
}
